<app-header></app-header>

<!-- Subliminal YAML messaging - Matrix-style cascade -->
<div class="yaml-cascade-container" [class.active]="showCascade">
  @for (msg of cascadeMessages; track msg) {
    <div
      class="cascade-message"
      [style.left.%]="msg.left"
      [style.animation-delay.ms]="msg.delay"
      [style.font-size.px]="msg.size">
      {{ msg.text }}
    </div>
  }
</div>

<div class="stepper">
  <mat-stepper
    [linear]="true"
    [orientation]="(stepperOrientation | async)!"
    class="stepper"
    #myStepper
    >
    <mat-step [stepControl]="firstFormGroup" label="Select Release Definition">
      <form [formGroup]="firstFormGroup">
        <mat-form-field appearance="fill" style="display: flex">
          <mat-label>Release</mat-label>
          <input
            placeholder="Release Definition Name"
            #releaseInput
            type="text"
            matInput
            formControlName="releaseDefinition"
            [matAutocomplete]="auto"
            required
            />
          <mat-autocomplete
            #auto="matAutocomplete"
            [displayWith]="displayRcName"
            >
            @for (
              releaseDefinition of filteredReleaseDefinitions | async
              ; track
              releaseDefinition) {
              <mat-option
                [value]="releaseDefinition"
                >
                {{ releaseDefinition.name }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        <br />
        <div >
          <button
            mat-raised-button
            class="button"
            (click)="
              getReleaseDefinitionChanges(
                this.firstFormGroup.value.releaseDefinition.id,
                this.defaultOrg!.accountName,
                this.defaultProject!
              )
            "
            >
            Next
          </button>
        </div>
      </form>
    </mat-step>
    <mat-step [stepControl]="secondFormGroup" label="Review">
      <mat-label
        ><strong>Org: </strong>{{ this.defaultOrg?.accountName }}</mat-label
        ><br />
        <mat-label><strong>Project: </strong>{{ this.defaultProject }}</mat-label
        ><br />
        <mat-label
          ><strong>Pipeline: </strong
          ><a
          rel="noopener"

          target="_blank"
          href="https://dev.azure.com/{{ this.defaultOrg?.accountName }}/{{
            this.defaultProject
          }}/_release?definitionId={{
            this.firstFormGroup.value.releaseDefinition.id
          }}"
          >{{ this.firstFormGroup.value.releaseDefinition.name }}</a
          ></mat-label
          >
          <br />
          @if (this.jitFinished) {
            @if (
              this.hasPreValidationErrors) {
              <span>
                <mat-label class="mat-label-validation-error"
                  ><strong><mat-icon>error</mat-icon> Please address below issues then request review.</strong>
                </mat-label>
              </span>
            } @else {
              @if (this.hasPreValidationWarnings) {
                <span>
                  <mat-label class="mat-label-validation-warning"
                    ><strong
                    ><mat-icon >warning</mat-icon> There are warnings in the validation checks. Please review and
                    request review.</strong
                    >
                  </mat-label>
                </span>
              }
            }
          }

          <br />
          <button
            mat-raised-button
            class="button"
            matStepperPrevious
            (click)="clearPreValidateTable()"
            >
            Back
          </button>
          <button
            mat-raised-button
            class="button"
            [disabled]="!this.firstFormGroup.valid"
        (click)="
          unlockRelease(
            this.firstFormGroup.value.releaseDefinition.id,
            this.defaultOrg!.accountName,
            this.defaultProject!
          )
        "
            >
            <span class="material-icons">lock_open</span>
          </button>
          @if (this.isPlatform) {
            <button
              mat-raised-button
              class="button"
              [disabled]="!this.firstFormGroup.valid"
        (click)="
          lockRelease(
            this.firstFormGroup.value.releaseDefinition.id,
            this.defaultOrg!.accountName,
            this.defaultProject!
          )
        "
              >
              <span class="material-icons">lock</span>
            </button>
          }
          <button
            mat-raised-button
            class="button"
        (click)="
          sendPipelineReviewRequest(
            this.defaultOrg!.accountName,
            this.defaultProject!,
            this.firstFormGroup.value.releaseDefinition,
            false
          )
        "
            >
            Request Review
          </button>
          <button
            mat-raised-button
            class="button"
        (click)="
          sendPipelineReviewRequest(
            this.defaultOrg!.accountName,
            this.defaultProject!,
            this.firstFormGroup.value.releaseDefinition,
            true
          )
        "
            >
            Force Review
          </button>
        </mat-step>
        <mat-step [stepControl]="thirdFormGroup" label="Finished">
          @if (
            this.jitFinished &&
            !this.pipelineReviewRequestSent &&
            !this.pipelineLockedMessageSent
            ) {
            <mat-label>
              <strong>
                <a
                  rel="noopener"
                  target="_blank"
              href="https://dev.azure.com/{{ this.defaultOrg?.accountName }}/{{
                this.defaultProject
              }}/_release?definitionId={{
                this.firstFormGroup.value.releaseDefinition.id
              }}"
                  >
                  {{ this.firstFormGroup.value.releaseDefinition.name }}
                </a>
                was successfully {{ this.rcAction }} at
                <span class="rcAction"> {{ this.rcActionTime }}.</span>
              </strong>
            </mat-label>
          }

          @if (
            this.pipelineReviewRequestSent &&
            (!hasPreValidationErrorsOrWarnings || forceReviewRequested)
            ) {
            <mat-label>
              <strong
                >A pipeline review request for
                <a
                  rel="noopener"
                  target="_blank"
              href="https://dev.azure.com/{{ this.defaultOrg?.accountName }}/{{
                this.defaultProject
              }}/_release?definitionId={{
                this.firstFormGroup.value.releaseDefinition.id
              }}"
                  >{{ this.firstFormGroup.value.releaseDefinition.name }}</a
                  >
                  was posted to Slack at<span class="rcAction">
                  {{ this.rcActionTime }}.</span
                  >
                </strong>
              </mat-label>
            }

            @if (
              this.pipelineLockedMessageSent && !hasPreValidationErrorsOrWarnings
              ) {
              <mat-label>
                <strong
                  ><a
                  rel="noopener"
                  target="_blank"
              href="https://dev.azure.com/{{ this.defaultOrg?.accountName }}/{{
                this.defaultProject
              }}/_release?definitionId={{
                this.firstFormGroup.value.releaseDefinition.id
              }}"
                  >{{ this.firstFormGroup.value.releaseDefinition.name }}</a
                  >
                  passed validation and was automatically locked at<span
                  class="rcAction"
                  >
                  {{ this.rcActionTime }}.</span
                  >
                </strong>
              </mat-label>
            }
            <br />
            @if (this.jitFinished) {
              @if (
                this.hasPreValidationErrors) {
                <span>
                  <mat-label class="mat-label-validation-error"
                    ><strong><mat-icon>error</mat-icon> Please address below issues then request review.</strong>
                  </mat-label>
                </span>
              } @else {
                @if (this.hasPreValidationWarnings) {
                  <span>
                    <mat-label class="mat-label-validation-warning"
                      ><strong
                      ><mat-icon >warning</mat-icon> There are warnings in the validation checks. Please review and
                      request review.</strong
                      >
                    </mat-label>
                  </span>
                }
              }
            }

            <br /><br />
            <button
              mat-raised-button
              class="button"
              matStepperPrevious
              (click)="clearPreValidateTable()"
              >
              Back
            </button>
            <button mat-raised-button class="button" (click)="reload()">Home</button>
            <button
              mat-raised-button
              class="button"
        (click)="
          sendPipelineReviewRequest(
            this.defaultOrg!.accountName,
            this.defaultProject!,
            this.firstFormGroup.value.releaseDefinition,
            false
          )
        "
              >
              Request Review
            </button>

            <button
              mat-raised-button
              class="button"
          (click)="
            sendPipelineReviewRequest(
              this.defaultOrg!.accountName,
              this.defaultProject!,
              this.firstFormGroup.value.releaseDefinition,
              true
            )
          "
              >
              Force Review
            </button>

            <div class="yaml-hint">
              <small>💡 <em>Pro tip: YAML pipelines don't need JIT access!</em></small>
            </div>
          </mat-step>
        </mat-stepper>
      </div>

      @if (isSecondOrThirdStep()) {
        <mat-tab-group
          style="min-width: 55%"
          animationDuration="0ms"
          [selectedIndex]="getSelectedIndex()"
          >
          <mat-tab label="Pipeline Changes">
            <br />
            <app-mario
              [inRcJit]="true"
              [lastUnlockedReleaseRevision]="this.lastUnlockedReleaseRevision!"
              [currentReleaseRevison]="this.currentReleaseRevision!"
            ></app-mario>
          </mat-tab>
          <mat-tab label="Validation Checks">
            @if (this.jitFinished && hasPreValidationErrorsOrWarnings) {
              <div class="accordion-outer-container">
                <div class="accordion-container">
                  <mat-accordion [multi]="true">
                    @for (result of validationEnvironments; track result) {
                      <mat-expansion-panel
                        [expanded]="true"
                        >
                        <mat-expansion-panel-header class="panel-header">
                          <mat-panel-title class="prevalidate-mat-title">
                            <strong>{{ result.EnvironmentName }}</strong>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        @for (error of result.ValidationResults | keyvalue; track error) {
                          <mat-expansion-panel [expanded]="false">
                            <mat-expansion-panel-header class="panel-header">
                              <mat-panel-title class="prevalidate-mat-title">{{
                                error.key
                              }}</mat-panel-title>
                            </mat-expansion-panel-header>
                            @for (error of error.value; track error) {
                              <div
                                class="error-details"
                                [class.warning-details]="error.IsWarning"
                                >
                                <p class="property">
                                  <strong>Description:</strong>
                                  <span
                                    [innerHTML]="sanitizeHtml(error.Message)"
                                  ></span>
                                </p>
                              </div>
                            }
                          </mat-expansion-panel>
                        }
                      </mat-expansion-panel>
                    }
                  </mat-accordion>
                </div>
              </div>
            }
          </mat-tab>
        </mat-tab-group>
      }



